// extracted by mini-css-extract-plugin
export var divider = "_st-0";
export var systemMessage = "_st-1";